export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  // document.cookie = `${name}=${encodeURIComponent(
  //   JSON.stringify(value),
  // )};${expires};path=/`;
  document.cookie = [
    `${name}=${encodeURIComponent(JSON.stringify(value))}`,
    expires,
    "path=/",
    "Secure",
    "SameSite=Strict"
  ].join("; ");
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
    }
  }
  return null;
};
